var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"600px"}},[_c('v-chart',{attrs:{"option":_vm.option,"autoresize":""},on:{"zr:click":_vm.handleZrClick,"click":_vm.handleClick}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }